module.exports = __webpack_public_path__ + "assets/img/advantages-icon.495de466.png";